import React, {useState, useEffect, useContext} from 'react';
import maincss from './MainCSS.module.css';
import Cookies from 'js-cookie';
import { useNavigate } from 'react-router-dom';
import Header from './Header';
import { urlContext } from './UrlContext';

const AllClients = () => {

    const { baseurl } = useContext(urlContext);

    const url = baseurl + "/allClients.php";

    let data;

    const [showClients, setShowClients] = useState();
    const [clientSn, setClientSn] = useState();
    const navigate = useNavigate();

    useEffect(() => {
        getClients();
    })

    const viewClient = (event) => {
        event.preventDefault();

        navigate('/client');
    }

    const handleHover = (row) => {
        Cookies.set('sn', row.sn);
        setClientSn({sn: Cookies.get('sn')});
    }

    const getClients = () => {
        fetch(url)
        .then(response => response.json())
        .then(responseData => {

            data = responseData.map(function (row) {

                return (
                    <tr key={row.sn} onMouseEnter={() => handleHover(row)}>
                        <td>{row.sn}</td>
                        <td>{row.clientname}</td>
                        <td>{row.accountno}</td>
                        <td>{row.phoneno}</td>
                        <td>{row.amount}</td>
                        <td>{row.router}</td>
                        <td>{row.ip}</td>
                        <td style={{color: row.clientstatus === "PAID" ? "green" : "red"}}>{row.clientstatus}</td>
                        <td><div className={maincss.btnView} onClick={viewClient}>View</div></td>
                    </tr>
                )
            })
            setShowClients(data);
        })
    }

    return (
        <div>
            <Header />
            <div className={maincss.content}>
                <table>
                    <tr>
                        <th>Sn</th>
                        <th>Client Name</th>
                        <th>Account No</th>
                        <th>Phone No</th>
                        <th>Amount</th>
                        <th>Router</th>
                        <th>Ip</th>
                        <th>Status</th>
                        <th>Action</th>
                    </tr>
                    {showClients}
                </table>
            </div>
        </div>
    )
}

export default AllClients;